// French locale - canonical source of truth.
// EN and PL inherit from this; missing keys fall back to FR.
const fr = {
  // Brand
  brand: {
    name: "HejPoland",
    tagline: "Guide francophone pour s'installer en Pologne",
    domain: "hejpoland.com",
  },

  // Navigation
  nav: {
    logement: "Logement",
    coutDeLaVie: "Coût de la vie",
    demarches: "Démarches",
    travailler: "Travailler",
    entrepreneuriat: "Entrepreneuriat",
    sante: "Santé",
    education: "Éducation",
    search: "Rechercher...",
    menu: "Menu",
  },

  // Hero (homepage)
  hero: {
    chip: "Guide francophone pour s'installer en Pologne",
    title: "Tout pour réussir votre installation en Pologne",
    subtitle: "Comparatifs de loyers, calculateur de budget, démarches administratives, entrepreneuriat. Des données vérifiées et mises à jour, des étapes claires.",
    searchPlaceholder: "Cherchez une ville, une démarche, un sujet...",
    explore: "Explorer",
    statCities: "7 villes analysées",
    statNbp: "Taux NBP en direct",
    statRgpd: "Conforme RGPD",
  },

  // Home sections
  home: {
    sectionsChip: "Explorer les sections",
    sectionsTitle: "Une plateforme, tous les sujets pour s'installer en Pologne",
    sectionsSub: "Du logement aux démarches administratives en passant par la création d'entreprise, retrouvez toutes les informations pratiques sourcées et chiffrées.",
    housingChip: "Logement",
    housingTitle: "Loyers moyens par ville (1 chambre centre)",
    housingSeeAll: "Voir le comparateur complet →",
    ctaTitle: "Restez informé des actualités polonaises",
    ctaSub: "Recevez chaque mois nos analyses sur la fiscalité, le marché du logement, les démarches et les opportunités professionnelles en Pologne.",
    discover: "Découvrir",
    comingSoonBadge: "Bientôt",
    cities: {
      title: "Où vivre en Pologne",
      intro: "Des grandes métropoles à la côte baltique, chaque ville polonaise a son caractère. Découvrez celles qui accueillent déjà des francophones.",
      discoverCta: "Découvrir",
    },
    connaissances: {
      title: "Connaissances sur la Pologne",
      intro: "Comprendre la Pologne au-delà des démarches, son actualité, sa politique et sa société.",
      explore: "Explorer les sujets",
    },
    blog: {
      title: "Sur le blog",
      intro: "Nos analyses pour préparer votre installation.",
      readMore: "Lire l'article",
      seeAll: "Voir tous les articles",
    },
  },

  // Quick links cards
  links: {
    logementDesc: "Comparateur de loyers et achats par ville",
    coutDesc: "Budget mensuel et comparatifs",
    demarchesDesc: "Karta pobytu, PESEL, NIP, banque",
    travaillerDesc: "Salaires réels, contrats, brut-net et secteurs qui recrutent des francophones.",
    entrepreneuriatDesc: "JDG, Sp. z o.o., ZUS, fiscalité",
    santeDesc: "NFZ, LuxMed, Medicover",
    educationDesc: "Écoles francophones, crèches",
  },

  // Housing page
  housing: {
    chip: "Logement",
    title: "Comparateur de loyers en Pologne",
    intro: "Données médianes issues des contributions de la communauté Numbeo, complétées par les statistiques officielles polonaises (GUS BDL).",
    overview: "Aperçu par ville",
    filterTitle: "Filtrer par critères",
    rentT2Center: "Loyer T2 centre",
    rent1brCenter: "Loyer 1 chambre centre",
    buyPerM2: "Achat",
    perM2: "zł/m²",
    tableCity: "Ville",
    tableType: "Type",
    tableZone: "Localisation",
    tableRentMin: "Loyer min",
    tableRentAvg: "Loyer moyen",
    tableRentMax: "Loyer max",
    tableRentRange: "Fourchette",
    tableBuy: "Prix d'achat zł/m²",
    tipsTitle: "Conseils pratiques",
    noResults: "Aucun résultat avec ces filtres",
    allCities: "Toutes les villes",
    allTypes: "Tous les biens",
    fullCity: "Toute la ville",
    typeStudio: "Studio",
    typeT2: "T2 (2 pièces)",
    typeT3: "T3 et plus",
    type1br: "1 chambre",
    type3br: "3 chambres",
    zoneCenter: "Centre-ville",
    zoneOutside: "Hors centre",
    zonePeripherie: "Périphérie",
    tips: [
      { title: "Caution", body: "Généralement 1 mois de loyer (parfois 2). Toujours exigée par écrit, remboursable à l'état des lieux." },
      { title: "Contrat", body: "Vérifiez la durée (umowa najmu okazjonalnego vs standardowego). Le bail standard offre plus de protection au locataire." },
      { title: "Charges", body: "Les charges (czynsz administracyjny) sont parfois incluses, parfois en sus. Demandez le détail avant de signer." },
      { title: "Pièges à éviter", body: "Méfiez-vous des annonces trop attractives. Visitez toujours en personne. Évitez de payer avant la signature." },
    ],
  },

  // Cost of living page
  col: {
    chip: "Coût de la vie",
    title: "Le coût de la vie en Pologne",
    intro: "Budget mensuel comparé entre villes polonaises et villes francophones de référence. Tous les montants sont exprimés en zlotys (PLN) pour faciliter la comparaison directe.",
    compareTitle: "Budget mensuel comparé (1 personne)",
    compareSource: "Données indicatives compilées à partir de sources publiques (Numbeo, GUS, Eurostat). Toutes les valeurs converties en PLN pour comparaison directe. Mise à jour manuelle.",
    legendHousing: "Logement",
    legendLife: "Vie",
    detailTitle: "Détail des prix par ville",
    cats: { alimentation: "Alimentation", transports: "Transports", services: "Services", loisirs: "Loisirs", sante: "Santé" },
  },

  // Budget calculator
  budget: {
    title: "Calculateur de budget",
    sub: "Estimation mensuelle personnalisable",
    items: {
      rent: "Logement",
      food: "Alimentation",
      transport: "Transports",
      utilities: "Charges (eau/élec/internet)",
      leisure: "Loisirs",
      other: "Autres",
    },
    total: "Total mensuel à",
    perMonth: "/ mois",
    reset: "Réinitialiser sur la moyenne",
  },

  // Currency converter
  currency: {
    title: "Convertisseur de devises",
    sub: "Source officielle : Banque Nationale de Pologne",
    amount: "Montant",
    to: "Vers",
    swap: "Inverser",
    nbpDate: "Taux NBP du",
    historyTitle: "Évolution sur 30 jours",
  },

  // Poland map
  map: {
    title: "Carte interactive",
    sub: "Cliquez sur une ville pour découvrir sa fiche complète",
  },

  // Newsletter
  newsletter: {
    title: "Restez informé",
    sub: "Une newsletter mensuelle. Pas de spam, désinscription en 1 clic.",
    placeholder: "vous@email.com",
    submit: "S'inscrire",
    consent: "J'accepte de recevoir la newsletter et la",
    consentLink: "politique de confidentialité",
    consentEnd: "(RGPD).",
    consentError: "Veuillez accepter la politique de confidentialité.",
    success: "Vérifiez votre boîte mail pour confirmer votre inscription !",
    alreadyConfirmed: "Cet email est déjà confirmé.",
    almost: "Presque terminé !",
    almostSub: "Un email de confirmation vient de vous être envoyé. Pensez à vérifier vos spams.",
    errorGeneric: "Erreur lors de l'inscription.",
  },

  // City detail
  city: {
    back: "Toutes les villes",
    inhabitants: "habitants",
    budgetEstimated: "Budget mensuel estimé",
    housingTitle: "Logement à",
    pricesTitle: "Prix du quotidien",
    newsletterCity: "Recevez nos prochaines analyses sur",
    newsletterCitySub: "Quartiers, nouveaux projets, évolutions des prix.",
    tableType: "Type",
    tableZone: "Zone",
    tableRentMin: "Loyer min",
    tableRentAvg: "Moyenne",
    tableRentMax: "Loyer max",
    tableBuy: "Achat zł/m²",
    notFound: "Ville introuvable",
    back2: "Retour",
    loading: "Chargement...",

    // Numbeo sections (refonte CityDetail)
    rentsTitle: "Loyers à",
    rentsType: "Type d'appartement",
    buyTitle: "Prix d'achat au m²",
    buyLocation: "Localisation",
    colMin: "Min",
    colAvg: "Moyenne",
    colMax: "Max",
    dailyPricesTitle: "Prix du quotidien",
    dailyPricesIntro: "Données médianes issues des contributions de la communauté Numbeo.",
    numbeoAttribution: "Source : Numbeo (médianes contributions communauté)",
    numbeoLastUpdate: "Dernière MAJ Numbeo",
    numbeoOpen: "Voir sur Numbeo",
    contributors: "{n} contributeurs sur 12 mois",
    entries: "{n} entrées sur 12 mois",
    completeness: "Complétude {pct}%",
    noNumbeoData: "Données Numbeo non disponibles pour cette ville.",
    categoryRestaurants: "Restaurants & sorties",
    categoryGroceries: "Courses",
    categoryTransport: "Transports",
    categoryRents: "Loyers",
    categoryBuy: "Achat immobilier",
    categoryUtilities: "Charges mensuelles",
    categoryChildcare: "Garde d'enfants & éducation",
    categorySalary: "Salaires & finance",
    categoryLeisure: "Sport & loisirs",
  },

  // Confirm / unsubscribe pages
  confirm: {
    confirming: "Confirmation en cours...",
    successTitle: "Inscription confirmée !",
    successBody: "Vous recevrez nos prochaines analyses sur la Pologne par email.",
    alreadyTitle: "Déjà inscrit",
    alreadyBody: "L'adresse {email} est déjà confirmée.",
    invalidTitle: "Lien invalide",
    invalidBody: "Le lien a peut-être expiré ou a déjà été utilisé.",
    home: "Retour à l'accueil",
    unsubTitle: "Désinscription effectuée",
    unsubBody: "Vous ne recevrez plus aucun email de notre part.",
    unsubLoading: "Traitement...",
  },

  // Coming soon
  comingSoon: {
    notify: "Soyez prévenu dès la publication de cette section.",
    back: "← Retour à l'accueil",
  },

  // Cookies
  cookies: {
    title: "Cookies",
    body: "Nous utilisons des cookies pour mesurer l'audience et améliorer votre expérience. Aucun tracking publicitaire.",
    accept: "Accepter",
    reject: "Refuser",
  },

  // Footer
  footer: {
    description: "Plateforme d'information centralisée pour les francophones qui envisagent de s'installer en Pologne. Données mises à jour, comparatifs chiffrés, démarches expliquées.",
    sections: "Sections",
    legal: "Légal",
    mentions: "Mentions légales",
    privacy: "Confidentialité",
    cgu: "CGU",
    methodology: "Méthodologie & Sources",
    copy: "© {year} HejPoland. Données fournies à titre informatif.",
    disclaimer: "Toujours vérifier auprès des autorités compétentes pour les démarches officielles.",
  },

  // Language banner (shown on /en/ and /pl/)
  langBanner: {
    enTitle: "English version coming soon",
    enBody: "We're showing the French version for now. Sign up to be notified when English content goes live.",
    plTitle: "Wkrótce dostępna polska wersja",
    plBody: "Tymczasowo pokazujemy francuską wersję. Zapisz się, aby otrzymać powiadomienie.",
    dismiss: "Fermer",
    switchToFr: "Voir en français",
  },

  // Legal pages
  legal: {
    mentions: {
      title: "Mentions légales",
      body: [
        ["Éditeur", "Le site HejPoland (hejpoland.com) est édité à titre informatif. Tous les contenus relatifs aux démarches administratives, fiscales ou juridiques sont fournis à titre indicatif et ne se substituent pas à un conseil professionnel."],
        ["Hébergement", "Nom de domaine enregistré auprès d'Infomaniak Network SA, Rue Eugène-Marziano 25, 1227 Genève, Suisse. Hébergeur applicatif : Emergent Labs Inc, 2380 Via Espada, Pleasanton, California 94566, États-Unis. Contact : support@emergent.sh."],
        ["Responsabilité", "Malgré nos efforts pour fournir des informations actualisées et exactes, HejPoland décline toute responsabilité quant à l'utilisation faite des informations publiées. Vérifiez systématiquement auprès des autorités compétentes (Urząd Wojewódzki, ZUS, Urząd Skarbowy, etc.)."],
        ["Propriété intellectuelle", "Les contenus rédactionnels, graphiques et données originales sont la propriété de HejPoland. Toute reproduction nécessite une autorisation préalable."],
        ["Contact", "Pour toute question : contact@hejpoland.com"],
      ],
    },
    privacy: {
      title: "Politique de confidentialité",
      body: [
        ["Données collectées", "Nous collectons uniquement les données strictement nécessaires : adresse email (newsletter), préférences locales (stockées dans votre navigateur via localStorage)."],
        ["Finalité", "Les emails servent uniquement à l'envoi de notre newsletter et aux emails transactionnels (confirmation, désinscription). Nous n'utilisons pas vos données à des fins publicitaires et ne les partageons avec aucun tiers."],
        ["Double opt-in", "Conformément au RGPD, votre inscription nécessite une double confirmation : saisie du formulaire puis clic sur un lien envoyé par email."],
        ["Hébergement des emails", "Nos emails transactionnels sont envoyés via Resend (région UE - Ireland). L'expéditeur newsletter est newsletter@hejpoland.com et l'expéditeur transactionnel noreply@hejpoland.com. Le Reply-To est contact@hejpoland.com."],
        ["Hébergement et transferts hors de l'Union européenne", "L'application est hébergée par Emergent Labs Inc, société établie aux États-Unis. Certaines données techniques de navigation, notamment l'adresse IP et les données de mesure d'audience, peuvent donc être traitées en dehors de l'Union européenne. Ces transferts sont encadrés par les garanties appropriées prévues par le règlement général sur la protection des données. La mesure d'audience s'appuie sur Google Analytics, dont les données peuvent également être traitées aux États-Unis."],
        ["Durée de conservation", "Les adresses email confirmées sont conservées tant que vous restez inscrit. Après désinscription, elles sont anonymisées sous 30 jours."],
        ["Vos droits", "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité. Pour exercer ces droits : contact@hejpoland.com"],
        ["Cookies", "Nous utilisons uniquement des cookies fonctionnels et de mesure d'audience qui ne collectent pas de données personnelles identifiantes."],
      ],
    },
    cgu: {
      title: "Conditions générales d'utilisation",
      body: [
        ["Objet", "Les présentes conditions régissent l'utilisation du site HejPoland (hejpoland.com)."],
        ["Accès", "Le site est accessible gratuitement. Aucune création de compte n'est requise pour la consultation."],
        ["Newsletter", "L'inscription à la newsletter est gratuite et résiliable à tout moment via le lien présent dans chaque email."],
        ["Disclaimer informationnel", "Les contenus relatifs aux prix, démarches, lois et règlements sont fournis à titre indicatif et peuvent évoluer. Vérifiez toujours auprès des sources officielles."],
        ["Contact", "Pour toute question concernant ces CGU : contact@hejpoland.com"],
      ],
    },
  },

  // Common
  common: {
    loading: "Chargement...",
    cancel: "Annuler",
    save: "Enregistrer",
    dataError: "Impossible de charger les données pour le moment, veuillez réessayer dans quelques instants.",
    retry: "Réessayer",
    lastUpdated: "Dernière mise à jour",
    indicativeData: "Données indicatives à vérifier auprès des sources originales.",
  },

  // Methodology page
  methodology: {
    chip: "Transparence",
    title: "Méthodologie & Sources",
    intro: "Soyons transparents : les chiffres affichés sur HejPoland (prix de loyers, coût de la vie, budgets mensuels) sont issus de sources publiques reconnues. Les données Numbeo (35 indicateurs par ville) sont collectées manuellement depuis la plateforme et mises à jour trimestriellement. Les données de population sont récupérées automatiquement via l'API officielle GUS BDL. Les taux de change PLN sont récupérés en temps réel via l'API officielle du NBP.",
    howTitle: "Comment les données sont compilées",
    howBody: "Notre équipe sélectionne des fourchettes plausibles à partir de sources publiques reconnues (Numbeo, GUS, plateformes immobilières polonaises). Les prix (loyers, coût de la vie) sont saisis manuellement depuis Numbeo et rafraîchis trimestriellement. La population des villes est récupérée automatiquement via l'API GUS BDL (~1 fois par an). Les taux de change sont mis à jour automatiquement chaque jour ouvré via l'API NBP. Pour des prix réels et actuels, consultez systématiquement les sources originales avant toute décision.",
    sourcesTitle: "Sources de référence",
    frequencyTitle: "Fréquence de mise à jour",
    frequencyBody: "Les estimations de logement, coût de la vie et budgets sont rafraîchies manuellement par notre équipe. Les taux de change PLN sont mis à jour automatiquement chaque jour ouvré via l'API officielle de la Banque Nationale de Pologne (NBP), avec un cache serveur de 12h.",
    disclaimerTitle: "Disclaimer légal",
    disclaimerBody: "Les chiffres présentés sur HejPoland sont fournis à titre purement indicatif et ne constituent ni un conseil ni une garantie. Le marché du logement, l'inflation et les taux de change évoluent rapidement. Pour toute décision importante (signature de bail, achat immobilier, démarche administrative, déclaration fiscale), vérifiez systématiquement auprès des sources officielles citées ou consultez un professionnel.",
    consult: "Consulter",
    referenced: "Sources de référence",
    methodologyLabel: "Méthodologie",
    type: { housing: "Prix du logement", cost_of_living: "Coût de la vie", cities: "Démographie & contexte", budgets: "Budgets mensuels de référence", currency: "Taux de change PLN", gus_bdl: "Statistiques officielles GUS BDL" },
  },

  // Admin Sources page
  adminSources: {
    title: "Admin · Sources & mises à jour",
    intro: "Gestion des dates de mise à jour des données. Connectez-vous avec le secret admin pour modifier les timestamps et accéder à l'édition des valeurs.",
    promptSecret: "Entrez le secret admin",
    invalidSecret: "Secret admin invalide",
    logout: "Se déconnecter",
    nbpStatus: "État de la dernière synchronisation NBP",
    nbpCachedAt: "Cache local",
    nbpEffectiveDate: "Taux NBP effectif",
    nbpCurrencies: "Devises présentes",
    touch: "Marquer comme mis à jour",
    touched: "Mise à jour enregistrée",
    touchedAt: "Mis à jour à",
    columnSource: "Type de donnée",
    columnOfficial: "Sources de référence",
    columnLastUpdated: "Dernière maj",
    columnFrequency: "Fréquence",
    columnAction: "Action",
    needSecret: "Authentification requise",
    goToData: "Éditer les valeurs →",
    // GUS BDL section
    gusTitle: "Statistiques officielles GUS BDL",
    gusIntro: "Données officielles polonaises récupérées via l'API publique GUS BDL : population (S1, gmina) et prix moyen au m² (trimestriel, marché total, powiat). Refresh manuel, fallback automatique sur dernière valeur connue en cas d'échec.",
    gusRefresh: "Rafraîchir maintenant (7 villes)",
    gusRefreshing: "Récupération depuis stat.gov.pl...",
    gusLastRefresh: "Dernier refresh",
    gusNoRefresh: "Aucun refresh effectué",
    gusPopulation: "Population (S1)",
    gusPrice: "Prix moyen au m²",
    gusYear: "Année",
    gusQuarter: "Trimestre",
    gusOk: "OK",
    gusFailed: "Échec",
    gusOpenPortal: "Voir sur bdl.stat.gov.pl ↗",
    gusRefreshSuccess: "Refresh GUS terminé",
    gusRefreshError: "Erreur lors du refresh GUS",
  },

  // Admin Data CRUD page
  adminData: {
    title: "Admin · Édition des données",
    intro: "Modifiez directement les valeurs (prix, populations, budgets). Chaque enregistrement met à jour automatiquement le timestamp correspondant et trace la modification dans le journal d'audit.",
    tabCities: "Villes",
    tabHousing: "Logement",
    tabCol: "Coût de la vie",
    tabBudgets: "Budgets",
    tabAudit: "Journal d'audit",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Modifié",
    noChange: "Aucune modification",
    error: "Erreur",
    reset: "Annuler",
    edit: "Éditer",
    auditTitle: "Journal d'audit — 30 derniers jours",
    auditEmpty: "Aucune modification enregistrée pour le moment.",
    auditEntity: "Entité",
    auditId: "ID / Slug",
    auditChanges: "Changements",
    auditWhen: "Date",
    fields: {
      population: "Population",
      region: "Région",
      summary: "Description",
      image_url: "Image (URL)",
      name_fr: "Nom (FR)",
      name_pl: "Nom (PL)",
      rent_min: "Loyer min (zł)",
      rent_avg: "Loyer moyen (zł)",
      rent_max: "Loyer max (zł)",
      buy_per_m2: "Achat (zł/m²)",
      type: "Type",
      zone: "Zone",
      city_slug: "Ville",
      item: "Libellé",
      category: "Catégorie",
      price_pln: "Prix (zł)",
      unit: "Unité",
      rent: "Logement (zł)",
      food: "Alimentation (zł)",
      transport: "Transports (zł)",
      utilities: "Charges (zł)",
      leisure: "Loisirs (zł)",
      other: "Autres (zł)",
    },
  },

  // Admin Numbeo page (list + edit)
  adminNumbeo: {
    title: "Admin · Données Numbeo",
    intro: "Mise à jour manuelle trimestrielle des indicateurs Numbeo pour les 7 villes polonaises. Chaque enregistrement archive automatiquement la version précédente et journalise les changements cellule par cellule.",
    listHeading: "Choisir une ville à éditer",
    colCity: "Ville",
    colLastUpdate: "Dernière MAJ Numbeo",
    colCompleteness: "Complétude",
    colContributors: "Contributeurs (12 mois)",
    colEntries: "Entrées (12 mois)",
    colAction: "Action",
    edit: "Éditer",
    lastUpdateGlobal: "Dernière MAJ globale : il y a {n} jour(s)",
    lastUpdateNever: "Aucune mise à jour enregistrée",
    backToList: "← Retour à la liste",
    openNumbeo: "Ouvrir la page Numbeo source ↗",
    editTitle: "Éditer les données Numbeo",
    metaTitle: "Métadonnées Numbeo",
    metaContributors: "Contributeurs (12 mois)",
    metaEntries: "Entrées (12 mois)",
    metaLastUpdate: "Date dernière MAJ Numbeo",
    indicatorMin: "MIN",
    indicatorAvg: "MOYENNE",
    indicatorMax: "MAX",
    fieldsModified: "{n} champ(s) modifié(s)",
    noFieldsModified: "Aucune modification",
    btnCancel: "Annuler",
    btnReset: "Réinitialiser",
    btnSave: "Enregistrer les modifications",
    saving: "Enregistrement…",
    savedToast: "Modifications enregistrées",
    saveError: "Erreur lors de l'enregistrement",
    warnMinAvgMax: "Incohérence : MIN ≤ MOYENNE ≤ MAX",
    nullEmpty: "vide = null",
    completenessLabel: "Complétude",
    historyLabel: "Versions archivées",
    expandAll: "Tout déplier",
    collapseAll: "Tout replier",
  },
};

export default fr;
